document.addEventListener('DOMContentLoaded', ()=>{

    if( document.querySelectorAll(`.before_afterupdated__version_swp`).length > 0 ){
        new Swiper(".before_afterupdated__version_swp.swiper", {
            slidesPerView: 'auto',spaceBetween: 16,
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
            pagination: { el: ".swiper-pagination", clickable: true },
            breakpoints: { 749: { spaceBetween: 30 } }
        });
    }

    if( document.querySelectorAll(`.suitable__users__items`).length > 0 ){
        new Swiper(".suitable__users__items.swiper", {
            slidesPerView: 'auto',spaceBetween: 8,
            pagination: { el: ".swiper-pagination", clickable: true },
            breakpoints: { 749: { spaceBetween: 6.81 } }
        });
    }

    if( document.querySelectorAll(`.working__process__steps__items`).length > 0 ){
        new Swiper(".working__process__steps__items.swiper", {
            slidesPerView: 'auto',spaceBetween: 14,
            pagination: { el: ".swiper-pagination", clickable: true },
            breakpoints: { 749: { spaceBetween: 32 } }
        });
    } 

    if( document.querySelectorAll(`.trustpilot__widget__items_swp`).length > 0 ){
        new Swiper(".trustpilot__widget__items_swp.swiper", {
            slidesPerView: 1,spaceBetween: 24,
            navigation: { nextEl: ".trustpilot__widget__items_content_xt .swiper-button-next", prevEl: ".trustpilot__widget__items_content_xt .swiper-button-prev" },
            breakpoints: { 749: { spaceBetween: 32,slidesPerView: 1 }, 1024: { spaceBetween: 32,slidesPerView: 2 }, 1320: { spaceBetween: 32,slidesPerView: 4 } }
        });
    }
    
    document.querySelectorAll(`.tabs_content__analysis__tab_item_title`).forEach((el) => {
        el.addEventListener('click', (event) => {
            event.preventDefault();
            const tabIndex = event.currentTarget.dataset.tab;
            document.querySelectorAll(`.tabs_content__analysis__tab_item_title`).forEach(title => { title.classList.remove('active'); });
            event.currentTarget.classList.add('active');
            document.querySelectorAll(`.desktop_view .tabs_content__analysis__tabs_ct_nt___mn`).forEach((content) => { content.style.display = 'none'; content.style.opacity = '0'; content.style.transform = 'translateX(20px)'; content.style.transition = 'none'; content.classList.remove('active'); });
            const activeContent = document.querySelector(`.desktop_view .tabs_content__analysis__tabs_ct_nt___mn[data-tab-content="${tabIndex}"]`);
            if (activeContent) {
                activeContent.classList.add('active');
                activeContent.style.display = 'flex'; 
                requestAnimationFrame(() => { activeContent.style.transition = 'all 300ms ease-out'; activeContent.style.opacity = '1'; activeContent.style.transform = 'translateX(0)'; });
            }
        });
    });

    document.querySelectorAll(`.tabs_content__analysis__ct_dt_cp`).forEach((el)=>{
        el.addEventListener('click', (target)=>{
            target.preventDefault();
            document.querySelectorAll(`.this_mobile_design__lyt .tabs_content__analysis__tabs_ct_nt___mn`).forEach((content) => {
                if(target.target.closest('.tabs_content__analysis__tabs_ct_nt___mn') != content ){
                    content.classList.remove('active'); 
                    content.querySelector(`.tabs_content__analysis__ct_dt`).style.maxHeight = null;
                }
            });
            target.target.closest('.tabs_content__analysis__tabs_ct_nt___mn').classList.toggle('active');
            if( !target.target.closest('.tabs_content__analysis__tabs_ct_nt___mn').classList.contains('active') ){
                target.target.closest('.tabs_content__analysis__tabs_ct_nt___mn').querySelector(`.tabs_content__analysis__ct_dt`).style.maxHeight = null;
            }else{
                let CurrentScrollHeight = target.target.closest('.tabs_content__analysis__tabs_ct_nt___mn').querySelector(`.tabs_content__analysis__ct_dt`).scrollHeight;
                target.target.closest('.tabs_content__analysis__tabs_ct_nt___mn').querySelector(`.tabs_content__analysis__ct_dt`).style.maxHeight = `${CurrentScrollHeight}px`;
            }
            window.scrollTo({
                top: document.querySelector(`.tabs_content__analysis__wp`).offsetTop - 90,
                behavior: 'smooth'
            });            
        })
    }) 
    
    document.querySelectorAll(`.tabs__insigts_xt__main__button`).forEach((el)=>{
        el.addEventListener('click', (target)=>{
            target.preventDefault();
            let tabIndex = target.currentTarget.dataset.tab;
            document.querySelectorAll(`.tabs__insigts_xt__main__button`).forEach((el)=>{ el.classList.remove('active') });
            document.querySelectorAll(`.tabs__insigts_xt__main__content`).forEach((el)=>{ el.classList.remove('active') });
            target.currentTarget.classList.add('active');
            document.querySelector(`.tabs__insigts_xt__main__content[data-tab-content="${tabIndex}"]`).classList.add('active');
        })
    })

    document.querySelectorAll(`.tabs__insigts_xt__main__button_cp`).forEach((el)=>{
        el.addEventListener('click', (target)=>{
            target.preventDefault();
            let tabIndex = target.currentTarget.dataset.tab;
            document.querySelectorAll(`.tabs__insigts_xt__main__button`).forEach((el)=>{ el.classList.remove('active') });
            document.querySelectorAll(`.tabs__insigts_xt__main__button_cp`).forEach((el)=>{ el.classList.remove('active') });
            document.querySelectorAll(`.tabs__insigts_xt__main__content`).forEach((el)=>{ el.classList.remove('active') });
            document.querySelector(`.tabs__insigts_xt__main__button[data-tab="${tabIndex}"]`).classList.add('active');
            document.querySelector(`.tabs__insigts_xt__main__button_cp[data-tab="${tabIndex}"]`).classList.add('active');
            document.querySelector(`.tabs__insigts_xt__main__content[data-tab-content="${tabIndex}"]`).classList.add('active');
            window.scrollTo({
                top: document.querySelector(`.tabs__insigts_xt__main__wp`).offsetTop - 90,
                behavior: 'smooth'
            });            
        })
    })     

    const observerOptions = { threshold: 0.5 };
    const animateCircle = (el) => {
        const target = parseInt(el.getAttribute('data-percent'));
        const duration = 1500;
        let startTime = null;
        const textSpan = el.parentElement.querySelector('.trns_anl__content___briefly_item_txt');

        const step = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const currentPercent = Math.floor(progress * target);
            const currentDegrees = (progress * target / 100) * 360;
            const maskValue = `conic-gradient(#000 ${currentDegrees}deg, transparent ${currentDegrees}deg)`;
            el.style.webkitMaskImage = maskValue;
            el.style.maskImage = maskValue;
            if (textSpan) {
                textSpan.innerText = `${currentPercent}%`;
            }
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };

        window.requestAnimationFrame(step);
    };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCircle(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    document.querySelectorAll('.trns_anl__content___briefly_item_circle').forEach(circle => {
        observer.observe(circle);
    });

})